<style lang="less">
@import "./less/common.less";
.message-login-title {
  color: #e6a23c;
  font-size: 16px;
}
.message-login-txt {
  font-size: 16px;
}
.message-login-content {
  padding: 10px;
}
</style>
<template>
  <el-container class="layout">
    <div class="header-title">
      <div class="ch-title">
        {{userName}}-{{workShop}}
      </div>
    </div>
    <el-header>
      <div class="sign-out">
        <a href="javascript:;"
           @click="dialogVisible = true">
          <img src="./image/tuichu.png" />
        </a>
      </div>
    </el-header>
    <!-- 退出 提示框 start -->
    <ModalTips class="label-tips"
               :dialogVisible="dialogVisible"
               :title="title"
               :modal-append-to-body="false"
               :append-to-body="false"
               @close-modal="stop">
      <div slot="content">
        <i class="el-icon-warning"></i>
        <span>尊敬的{{userName}}用户,您确认退出该系统？</span>
      </div>
    </ModalTips>
    <!-- <el-dialog :title="title"
               :visible.sync="dialogVisible"
               width="30%"
               :append-to-body="true"
               :before-close="handleClose">
      <i class="el-icon-warning"></i>
      <span>尊敬的{{userName}}用户,您确认退出该系统？</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog> -->
    <!-- 退出 提示框 end -->
    <el-main>
      <router-view :isModalOld="dialogVisible" />
    </el-main>
  </el-container>
</template>
<script>
import { localToken } from "@/libs/util";
import { MessageBox } from "element-ui";
import axios from "axios";
import common from "@/libs/common";
import globConfig from "@/config/config";
import ModalTips from "@/components/modal/modalTips";
// import merge from 'webpack-merge';
import $ from "jquery";
export default {
  name: "layout",
  components: {
    ModalTips
  },
  data () {
    return {
      // 天气接口信息
      userName: "",
      workShop: "",
      // tenantName: "",
      dialogVisible: false,
      title: "提示",
      fullscreen: true
    };
  },
  methods: {
    handleBackHome () {
      this.$router.replace({ path: "/main" });
    },
    stop (flag) {
      let that = this;
      if (flag) {
        localToken.clearLocal();
        common.fullScreen(that.fullscreen)
        let path = "/login"
        let Tenant_Id = localToken.getTenant();
        if (Tenant_Id) {
          path = "/" + Tenant_Id + path
        }
        that.$router.push({
          path: path
        });
      }
      that.dialogVisible = false;
    }
  },
  mounted () {
    let that = this;
    that.userName = localToken.getUser();
    that.workShop = localToken.getWorkShopName();
  }
};
</script>
<style lang="less">
.el-loading-mask.is-fullscreen {
  z-index: 9999 !important;
}
.el-popper {
  z-index: 2010 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/layout.vue